import { computed, readonly, ref } from 'vue'

/**
 * Глобальное состояние баннера «доступна новая версия».
 *
 * Ref-ы объявлены на уровне модуля намеренно: флаг ставит проверка версии
 * (плагин app-update-check → useAppUpdate), а показывает баннер в лейауте —
 * им нужно одно общее состояние, как у «Сейчас мы закрыты» через рабочие часы.
 */
const hasUpdate = ref(false)
const latestVersion = ref('')
const isForced = ref(false)
/** Версия, баннер которой пользователь закрыл вручную (сбрасывается перезапуском приложения) */
const dismissedVersion = ref<string | null>(null)

export const useAppUpdateBanner = () => {
  /** Принудительное обновление закрыть нельзя — баннер висит до установки новой версии */
  const isVisible = computed(
    () => hasUpdate.value && (isForced.value || dismissedVersion.value !== latestVersion.value),
  )

  const setUpdateAvailable = (version: string, forced = false) => {
    hasUpdate.value = true
    latestVersion.value = version
    isForced.value = forced
  }

  const clearUpdate = () => {
    hasUpdate.value = false
    isForced.value = false
    latestVersion.value = ''
    dismissedVersion.value = null
  }

  const dismiss = () => {
    if (isForced.value) return
    dismissedVersion.value = latestVersion.value
  }

  return {
    isVisible,
    hasUpdate: readonly(hasUpdate),
    latestVersion: readonly(latestVersion),
    isForced: readonly(isForced),
    setUpdateAvailable,
    clearUpdate,
    dismiss,
  }
}
